import { render } from "./OrganizationTabs.vue?vue&type=template&id=e5182272&scoped=true"
import script from "./OrganizationTabs.vue?vue&type=script&lang=js"
export * from "./OrganizationTabs.vue?vue&type=script&lang=js"

import "./OrganizationTabs.vue?vue&type=style&index=0&id=e5182272&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e5182272"]])

export default __exports__